/** Ground slam (fx 'quake'): cracks and a dust ring from the caster, or the struck target. */
import { registerFx } from './registry';

const R = Math.random;

registerFx('quake', (host) => ({
  skill: ({ tgt, s, sx, sy, tx, ty, spot }) => {
    const [qx, qy] = spot ? [tx, ty] : s.aoe || !tgt ? [sx, sy] : [tx, ty];
    host.fx.push({
      type: 'crack',
      x: qx,
      y: qy,
      t: 0,
      life: 1.2,
      r: (s.aoe ?? 1.4) * 22,
      seed: R() * 999,
    });
    host.fx.push({
      type: 'shock',
      x: qx,
      y: qy,
      t: 0,
      life: 0.5,
      r: (s.aoe ?? 1.4) * 26,
      col: '220,170,100',
    });
    host.dust(qx, qy, 24, (s.aoe ?? 1.4) * 14, 70);
    host.impact('220,170,100', 0.12, 0.5, 6);
    host.sfx.boom();
  },
}));
